import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    basketMessages: null,
    basketTotalSum: null,
    basketItems: null,
    basketCount: null,
    currency: null,
};

// getters
const getters = {
    basketMessages: state => state.basketMessages,
    basketTotalSum: state => state.basketTotalSum,
    basketItems: state => state.basketItems,
    basketCount: state => state.basketCount,
    currency: state => state.currency,
};

// actions
const actions = {
    deleteBasketItem({ commit }, basketItemId) {
        let params = {
            'handler': 'basket',
            'func': 'deleteBasketItem',
            'basketItemId': basketItemId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setBasketItems', responseData.data.data.basketItems);
            commit('setBasketTotalSum', responseData.data.data.totalPrice);
            commit('setBasketCount', responseData.data.data.basketCount);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    addItemToBasket({ commit }, item){
        let params = {
            'handler': 'basket',
            'func': 'addItemToBasket',
            'productId': item.productId,
            'quantity': item.quantity
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get',  APP.ajax_endpoint, params, (responseData) => {
            commit('setBasketItems', responseData.data.data.basketItems);
            commit('setBasketTotalSum', responseData.data.data.totalPrice);
            commit('setBasketCount', responseData.data.data.basketCount);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeItemCount({ commit }, item){
        let params = {
            'handler': 'basket',
            'func': 'changeItemCount',
            'basketItemId': item.basketItemId,
            'quantity': item.quantity
        };

        _u.requestHttp('get',  APP.ajax_endpoint, params, (responseData) => {
            commit('setBasketItems', responseData.data.data.basketItems);
            commit('setBasketTotalSum', responseData.data.data.totalPrice);
            commit('setBasketCount', responseData.data.data.basketCount);
   
        });
    },
};

// mutations
const mutations = {
    setBasketMessages (state, messages) {
        state.basketMessages = messages;
    },
    setBasketTotalSum (state, sum) {
        state.basketTotalSum = sum;
    },
    setBasketItems (state, basketItems) {
        state.basketItems = basketItems;
    },
    setBasketCount (state, basketCount) {
        state.basketCount = basketCount;
    },
    setCurrency (state, currency) {
        state.currency = currency;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
